import React from 'react';

import { useField } from 'formik';

import TextInput from 'components-new/text-input/text-input';
import type { TextInputProps } from 'components-new/text-input/text-input';

interface TextFieldProps extends TextInputProps {
  name: string;
  showError?: boolean;
}

const TextField: React.FC<TextFieldProps> = ({
  name,
  showError = true,
  ...other
}) => {
  const [field, meta] = useField(name);

  return (
    <TextInput
      {...field}
      error={showError && meta.touched ? meta.error : undefined}
      {...other}
    />
  );
};

export default TextField;
